// Determine if version is greater than all the versions possible in the range.
const outside = require('./outside')
const gtr = (version, range, options) => outside(version, range, '>', options)
module.exports = gtr



//////////////////
// WEBPACK FOOTER
// ./~/jsonwebtoken/~/semver/ranges/gtr.js
// module id = 1930
// module chunks = 1